import React from 'react'

function FlavorsSizes() {
  return (
    <div>
        <section className="Flavors-sizes">
  <div className="container mt-3 pt-5">
    <div className="row" dir="rtl">
      <div className="col-12">
        <h2 className="text-center  wow animate__animated animate__fadeInDown">
          النكهات
        </h2>
        <div className="size">
          <div>
            <p className="wow animate__animated animate__fadeInRight">
              المقاس الصغير والمتوسط
            </p>
            <ul className="wow animate__animated animate__fadeInUp">
              <li>جبنة</li>
              <li>جبنة متبلة</li>
              <li>جبنة بالتوابل</li>
              <li>جبنة بالبصل</li>
              <li>خل وملح</li>
              <li>شطة وليمون</li>
              <li>طماطم</li>
              <li>كباب مشوي</li>
            </ul>
          </div>
          <div>
            <p className="wow animate__animated animate__fadeInLeft">
              المقاس الكبير
            </p>
            <ul className="wow animate__animated animate__fadeInUp">
              <li>طماطم</li>
              <li>جبنة متبلة</li>
              <li>شطة وليمون</li>
            </ul>
          </div>
        </div>
      </div>
      <div className="col-12 text-center">
        <h2 className="wow animate__animated animate__fadeInDown">
          الاوزان المتاحة
        </h2>
        <p className="text-dark wow animate__animated animate__fadeInUp">
          15 جم → حتى 30 جم
        </p>
        <p className="text-dark wow animate__animated animate__fadeInUp">
          30 جم → حتى 60 جم
        </p>
        <p className="text-dark wow animate__animated animate__fadeInUp">
          70 جم → حتى 120 جم
        </p>
      </div>
    </div>
  </div>
</section>

    </div>
  )
}

export default FlavorsSizes;